// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Events: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve" fill="currnetColor">
<g>
	<rect x="20.88" y="23.27" width="5.22" height="4.53"/>
	<rect x="28.29" y="23.27" width="5.22" height="4.53"/>
	<rect x="20.88" y="16.86" width="5.22" height="4.53"/>
	<rect x="28.29" y="29.67" width="5.22" height="4.53"/>
	<path d="M30.24,9.48c1.05,0,1.9-0.86,1.9-1.9V1.9c0-1.05-0.86-1.9-1.9-1.9c-1.04,0-1.9,0.85-1.9,1.9v5.68
		C28.34,8.63,29.2,9.48,30.24,9.48z"/>
	<rect x="28.29" y="16.86" width="5.22" height="4.53"/>
	<path d="M10.2,9.48c1.05,0,1.9-0.86,1.9-1.9V1.9c0-1.05-0.86-1.9-1.9-1.9C9.15,0,8.3,0.85,8.3,1.9v5.68
		C8.3,8.63,9.15,9.48,10.2,9.48z"/>
	<rect x="13.47" y="29.67" width="5.22" height="4.53"/>
	<rect x="6.06" y="23.27" width="5.22" height="4.53"/>
	<rect x="6.06" y="29.67" width="5.22" height="4.53"/>
	<rect x="20.88" y="29.67" width="5.22" height="4.53"/>
	<rect x="6.06" y="16.86" width="5.22" height="4.53"/>
	<path d="M37.21,3.56h-3.7v5.16c0,1.04-0.85,1.9-1.9,1.9h-2.76c-1.05,0-1.9-0.86-1.9-1.9V3.56H13.47v5.16c0,1.04-0.86,1.9-1.9,1.9
		H8.81c-1.05,0-1.9-0.86-1.9-1.9V3.56H2.79C1.25,3.56,0,4.81,0,6.34v30.09c0,1.53,1.25,2.79,2.79,2.79h34.43
		c1.53,0,2.79-1.25,2.79-2.79V6.34C40,4.81,38.75,3.56,37.21,3.56z M37.38,37.01H2.62V13.29h34.75V37.01z"/>
	<rect x="13.47" y="16.86" width="5.22" height="4.53"/>
	<rect x="13.47" y="23.27" width="5.22" height="4.53"/>
</g>
</svg>;
};

export default React.memo(Events);
